import { Alert } from "@hydrologiq/gql-experience/graphql"
import Figure from "@hydrologiq/shared/figures/generic/Figure"
import FigureContent from "../generic/FigureContent"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface AlertsProps {
  alerts: Alert[] | number | undefined
  loading: boolean
  error: string | undefined
}
function Alerts({ alerts, loading, error }: AlertsProps) {
  const alertCount =
    typeof alerts === "number"
      ? alerts
      : Array.isArray(alerts)
        ? alerts.reduce((acc, alert) => acc + alert.count, 0)
        : 0
  return (
    <Figure heading="Alerts" error={error ?? undefined} loading={loading} compact={isCompactFigure("summary")}>
      <FigureContent.SubText link={<FigureContent.Label>{alertCount === 0 ? "No active alerts" : "Requires attention"}</FigureContent.Label>}>current</FigureContent.SubText>
      <FigureContent.Value>{alertCount ?? 0}</FigureContent.Value>
    </Figure>
  )
}

export default Alerts
